import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { abortController } from 'store/utils';
import { getAvailableContinentsApi, getContinentsOverviewApi, getCountriesDictionaryApi } from './api';
const initialState = {
    dictionary: [],
    availableContinents: [],
    continentsOverview: undefined,
};
const actions = {
    getCountriesDictionary: async (_, { setState }) => {
        try {
            const { data } = await getCountriesDictionaryApi();
            setState((state) => {
                state.dictionary = data;
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    getAvailableContinents: async (_, { setState }) => {
        try {
            const { data } = await getAvailableContinentsApi();
            setState((state) => {
                state.availableContinents = data;
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    getContinentsOverview: async (_, { setState }) => {
        try {
            const { data } = await getContinentsOverviewApi();
            setState((state) => {
                state.continentsOverview = data;
            });
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
};
const store = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Countries')), { name: 'Countries' }));
